export default {
    SIGNIN: 0,
    LOADING: 1,
    CHANGE_PASSWORD: 2,
    TELLUSABOUTYOU: 3,
    TEAMSCALLINGLOCATION: 4,
};
